import React from 'react';

const CheckIcon = ({ color = '#222222', className = '' }) => (
  <svg
    className={className}
    data-testid="check-icon"
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.8937 7.74878L5.2487 8.10658L5.60365 7.74872L12.6479 0.646514C12.648 0.646398 12.6481 0.646281 12.6482 0.646164C12.6944 0.599891 12.7493 0.563164 12.8096 0.538085C12.8702 0.512942 12.9351 0.5 13.0006 0.5C13.0662 0.5 13.1311 0.512942 13.1916 0.538085C13.2519 0.563122 13.3067 0.599766 13.3529 0.645929C13.5494 0.845095 13.5492 1.16778 13.3524 1.36676C13.3524 1.3668 13.3523 1.36683 13.3523 1.36687L6.30785 8.46831L6.30767 8.46849L5.60085 9.18031L5.59976 9.18141C5.55381 9.22798 5.49906 9.26495 5.4387 9.29019C5.37834 9.31542 5.31357 9.32842 5.24815 9.32842C5.18272 9.32842 5.11795 9.31542 5.05759 9.29019C4.99723 9.26495 4.94248 9.22798 4.89653 9.18141L4.89569 9.18056L4.18969 8.46856L4.18949 8.46836L0.649492 4.90236L0.648782 4.90165C0.553502 4.80605 0.5 4.67659 0.5 4.54162C0.5 4.40665 0.553501 4.27718 0.648782 4.18159L0.648855 4.18151C0.695123 4.13507 0.750103 4.09823 0.810643 4.07308C0.871185 4.04794 0.936094 4.035 1.00165 4.035C1.0672 4.035 1.13211 4.04794 1.19265 4.07308C1.25305 4.09817 1.30792 4.1349 1.35412 4.18119C1.35422 4.1813 1.35433 4.18141 1.35444 4.18151L4.8937 7.74878Z"
      fill={color}
      stroke={color}
    />
  </svg>
);

export default CheckIcon;
